var _style, _g, _path, _g2, _g3, _path2, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 12,
    className: "st1",
    width: 1.7,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 12,
    className: "st1",
    width: 1.7,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7,
    y: 12,
    className: "st1",
    width: 1.7,
    height: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.3,6.6h-6.5V4.7c0-0.9-0.7-1.7-1.6-1.7h-4.3c-0.9,0-1.6,0.8-1.6,1.7v1.9H4.7v1.7h2.1v15.8 c0,1.6,1.3,2.9,2.9,2.9h10.7c1.6,0,2.9-1.3,2.9-2.9V8.4h2V6.6z M12.9,4.7h4.2v1.9h-4.2V4.7z M21.5,24.1c0,0.6-0.5,1.2-1.2,1.2H9.6 c-0.6,0-1.2-0.5-1.2-1.2V8.4h13V24.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,4C8.9,4,4,8.9,4,15s4.9,11,11,11c6.1,0,11-4.9,11-11S21.1,4,15,4z M16.4,21.1c0,0.1-0.1,0.3-0.3,0.3h-3.4 c-0.1,0-0.3-0.1-0.3-0.3v-2.4c0-0.1,0.1-0.3,0.3-0.3h3.4c0.1,0,0.3,0.1,0.3,0.3V21.1z M21.4,13.3c0,0.7-0.2,1.3-0.6,1.8 c-0.4,0.5-1,0.8-1.7,0.9l-2.1,0.3c-0.4,0.1-0.6,0.2-0.6,0.2c-0.1,0.1-0.1,0.2-0.1,0.4v0.5c0,0.1-0.1,0.3-0.3,0.3h-3.1 c-0.1,0-0.3-0.1-0.3-0.3c0-0.1,0-0.4,0-0.6c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-0.8,0.1-1.4,0.4-1.8c0.3-0.4,0.8-0.7,1.4-0.8 l2.6-0.5c0.4-0.1,0.6-0.2,0.7-0.3c0.1-0.1,0.2-0.3,0.2-0.5c0-0.4-0.2-0.5-0.3-0.6c-0.2-0.1-0.6-0.2-1.5-0.2H14 c-0.8,0-1.2,0.2-1.3,0.3c-0.2,0.2-0.3,0.6-0.3,1.2v0.2c0,0.1-0.1,0.3-0.3,0.3H9c-0.1,0-0.2-0.1-0.3-0.2c0-0.2,0-0.4-0.1-0.6 c0-0.2,0-0.4,0-0.6c0-1.3,0.4-2.2,1.2-2.7C10.7,8.9,12,8.6,14,8.6h2.7c1.6,0,2.8,0.2,3.5,0.6c0.8,0.5,1.1,1.2,1.1,2.2V13.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.9,25c-0.5,0-1-0.1-1.3-0.5l-6.5-8.1C4.3,15.8,5.3,14.8,6,14c0,0,1-1,1.5-0.3l4.8,6c0.2,0.2,0.6,0.2,0.7,0l9.3-14.1 C23,4.9,23.3,5.3,24,6c1,1,1.7,1.3,1.1,2L14.2,24.4C13.9,24.8,13.4,25,12.9,25z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.7,5v20h22.6V5H3.7z M4.9,18.2V6.2h20.3v14.8l-4.1-4.3l-5,4.2l-5.6-8.5L4.9,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.3,13.4c1.3,0,2.3-1,2.3-2.3c0-1.3-1-2.3-2.3-2.3c-1.3,0-2.3,1-2.3,2.3C18,12.4,19,13.4,20.3,13.4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.3,6.1c-1.3-1-3-0.9-4.2,0V5.8c0-0.4-0.4-0.8-0.8-0.8h-9.9C10.2,5,10,5.1,9.8,5.2l-6.2,6.2 c-0.1,0.1-0.2,0.4-0.2,0.6v12.2c0,0.4,0.4,0.8,0.8,0.8h16.1c0.4,0,0.8-0.4,0.8-0.8V17l4.8-6.1C27,9.3,26.8,7.2,25.3,6.1z M10.2,7.1 v4.6H5.6L10.2,7.1z M19.5,23.4H5v-10h6c0.4,0,0.8-0.4,0.8-0.8v-6h7.7V8l-5.4,6.9C14.1,15,14,15.1,14,15.1l-0.5,5.3 c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.1,0.5,0.1l5-1.7c0.1,0,0.2-0.1,0.2-0.2l0-0.1V23.4z M18.3,18.5l-3.7,1.3l0.3-3.9L18.3,18.5z  M25.1,10.2l-0.2,0.2l-3.8-3l0.2-0.2c0.8-1,2.3-1.2,3.4-0.4C25.7,7.7,25.9,9.2,25.1,10.2z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,27H6c-0.3,0-0.5-0.2-0.5-0.5v-23C5.5,3.2,5.7,3,6,3h18c0.3,0,0.5,0.2,0.5,0.5v23C24.5,26.8,24.3,27,24,27z M6.8,25.7 h16.4V4.3H6.8V25.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18.3,
    width: 11.9,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 21.7,
    width: 11.9,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6.6,
    width: 11.9,
    height: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.94acc1cf.svg";
export { ForwardRef as ReactComponent };